import { SetInstanceOf } from './instanceof';
import { BaseClass } from './base-class';
import { BindDescriptorOld, CopyClass, EXCLUDED_PROPERTY_NAMES, GetOwnPropertyKeys, GetPropertyDescriptors, SetClassName } from './helpers';
export function MakeFactory(create, factories, superClass, options = {}) {
    let _superClass = superClass;
    for (let i = factories.length - 1; i >= 0; i--) {
        _superClass = factories[i](_superClass);
    }
    const _class = create(_superClass);
    Object.defineProperty(_class, IS_FACTORY_CLASS, {
        value: true,
    });
    if (typeof options.name === 'string') {
        Object.defineProperty(_class, 'name', {
            configurable: true,
            enumerable: false,
            value: options.name,
            writable: false,
        });
    }
    if (Array.isArray(options.waterMarks)) {
        for (let i = 0, l = options.waterMarks.length; i < l; i++) {
            Object.defineProperty(_class, options.waterMarks[i], {
                value: true,
            });
        }
    }
    if (options.instanceOf !== void 0) {
        SetInstanceOf(options.instanceOf, _class);
    }
    return _class;
}
export function ClassToFactory(source) {
    return function (superClass, mode = 'auto') {
        let _class;
        if ((superClass === Object)
            || (superClass === BaseClass)) {
            _class = class extends source {
                constructor(args) {
                    super(...args);
                }
            };
            SetInstanceOf(superClass, _class);
        }
        else {
            _class = class extends superClass {
                constructor(...args) {
                    const ownArgs = args[0];
                    super(...args.slice(1));
                    let _this;
                    switch (mode) {
                        case 'auto':
                            try {
                                _this = source.apply(this, ownArgs);
                                if (_this === void 0) {
                                    _this = this;
                                }
                                mode = 'function';
                            }
                            catch (e) {
                                _this = Reflect.construct(source, ownArgs);
                                mode = 'class';
                            }
                            break;
                        case 'function':
                            _this = source.apply(this, ownArgs);
                            if (_this === void 0) {
                                _this = this;
                            }
                            break;
                        case 'class':
                            _this = Reflect.construct(source, ownArgs);
                            break;
                    }
                    if (this !== _this) {
                        const iterator = GetPropertyDescriptors(Object.getPrototypeOf(_this));
                        let result;
                        while (!(result = iterator.next()).done) {
                            const key = result.value[0];
                            if (!EXCLUDED_PROPERTY_NAMES.has(key)) {
                                Object.defineProperty(this, key, BindDescriptorOld(_this, key, result.value[1]));
                            }
                        }
                        const keys = GetOwnPropertyKeys(_this);
                        for (const key of keys) {
                            if (!EXCLUDED_PROPERTY_NAMES.has(key)) {
                                if (key in this) {
                                    console.warn(`Crossing properties !`);
                                }
                                Object.defineProperty(this, key, BindDescriptorOld(_this, key, Object.getOwnPropertyDescriptor(_this, key)));
                            }
                        }
                        Object.seal(_this);
                    }
                }
            };
            CopyClass(source, _class);
        }
        SetClassName(_class, source.name);
        return _class;
    };
}
export function HasFactoryWaterMark(_class, waterMark, direct = true) {
    return (_class[waterMark] === true) && (direct ? _class.hasOwnProperty(waterMark) : true);
}
const IS_FACTORY_CLASS = Symbol('is-factory-class');
export function IsFactoryClass(_class, direct = true) {
    return (_class[IS_FACTORY_CLASS] === true) && (direct ? _class.hasOwnProperty(IS_FACTORY_CLASS) : true);
}
export function SetSuperArgsForFactoryClass(args, superArgs) {
    if (Array.isArray(args[0])) {
        args[0] = superArgs;
        return args;
    }
    else {
        throw new TypeError(`Expected array as argument 0`);
    }
}
export function SetSuperArgsForStandardClass(args, superArgs) {
    for (let i = 0, l = superArgs.length; i < l; i++) {
        args[i] = superArgs[i];
    }
    return args;
}
export function GetSetSuperArgsFunction(isFactoryClass) {
    return isFactoryClass
        ? SetSuperArgsForFactoryClass
        : SetSuperArgsForStandardClass;
}
//# sourceMappingURL=factory.js.map